<template>
  <div>
    <v-main>
      <div style="overflow-x: hidden">
        <v-row style="padding: 1% 2%; height: 70px">
          <v-col xs="10" sm="10" md="10" lg="10">
            <h2>รับของรางวัล</h2>
          </v-col>
        </v-row>
        <v-container>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row style="padding-top: 20px; justify-content: center">
              <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                <v-row>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    class="padding-colH"
                  >
                    <p style="margin: 0px 0px">
                      รหัสของรางวัล <span style="color: red">*</span>
                    </p>
                  </v-col>
                  <v-col
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding: 0px 0px"
                  >
                    <v-text-field
                      v-model="checkCode"
                      label=""
                      solo
                      required
                      :append-outer-icon="'mdi-magnify'"
                      @click:append-outer="check()"
                      @keydown.enter="check()"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="status === true">
                  <v-container>
                    <v-card style="width: 100%">
                      <v-container>
                        <v-row>
                          <v-col>
                            <v-img
                              :src="d.pictureUrl"
                              :aspect-ratio="16 / 9"
                            ></v-img>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <h3 v-if="d.supply === 'coupon'">{{ d.remark }}</h3>
                            <h3 v-else>{{ d.name }}</h3>
                            <p>
                              {{
                                d.endDate !== null
                                  ? "หมดอายุ  " + thaiFormattedDate(d.endDate)
                                  : null
                              }}
                            </p>
                            <v-expansion-panels>
                              <v-expansion-panel v-if="d.supply !== 'coupon'">
                                <v-expansion-panel-header>
                                  เงื่อนไข
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                  {{ d.description }}
                                </v-expansion-panel-content>
                              </v-expansion-panel>

                              <v-expansion-panel v-if="d.supply === 'coupon'">
                                <v-expansion-panel-header>
                                  รายละเอียด
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                  รหัสสมาชิก: {{ d.memberId }}
                                  <hr />
                                  <div style="font-size: 14px">
                                    <v-img
                                      :src="d.linePicture"
                                      :alt="d.lineName"
                                      style="
                                        width: 100px;
                                        height: 100px;
                                        border-radius: 50%;
                                      "
                                    >
                                    </v-img>
                                    <br />
                                    ระดับสมาชิก: {{ d.levelName }} <br />
                                    ชื่อ - นามสกุล: {{ d.nameCustomer }} <br />
                                    เบอร์โทรศัพท์: {{ d.tel }} <br />
                                  </div>
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </v-expansion-panels>
                            <br />
                            <v-textarea
                              label="หมายเหตุ"
                              style="padding: 0px !important"
                              auto-grow
                              rows="1"
                              name="input-7-4"
                              outlined
                              dense
                              v-model="formUpdate.remark"
                            ></v-textarea>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <v-btn dark block color="#173053" @click="submit()"
                              >ยืนยัน</v-btn
                            >
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-container>
                </v-row>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import moment from 'moment'
export default {
  components: {
    moment
  },
  data () {
    return {
      session: this.$session.getAll(),
      valid: true,
      checkCode: '',
      shopId: null,
      d: [],
      status: false,
      formUpdate: {
        redeemStatus: 'use',
        remark: '',
        useDate: moment().format('YYYY-MM-DD HH:mm:ss'),
        userId: ''
      },
      formUpdate2: {
        redeemStatus: 'use',
        useDate: moment().format('YYYY-MM-DD HH:mm:ss')
      },
      memberId: null
    }
  },
  async mounted () {
    if (this.$session.getAll().data !== undefined) {
      if (this.$session.getAll().data.shopId === this.$route.query.shopId) {
        if (!this.$session.exists()) {
          this.$session.start()
          this.$session.set(
            'data',
            JSON.parse(localStorage.getItem('sessionData'))
          )
          location.reload()
        } else {
          if (this.$route.query.rewardCode) {
            await this.check()
          }
        }
      } else {
        if (this.$route.query.rewardCode) {
          this.$router.push(
            '/Core/Login?access=KNYW6L9LPgSgWPvMzGUBPhPXH52ZdndSpq4Ez8SXMzGu3tBvfEFCrYKK86usU7FE47VKpuVCqe3YPA2CHsnZXshcsKG7A4ZaEWUW&callBack=' +
              this.$route.fullPath
          )
        } else {
          if (this.$route.query.rewardCode) {
            await this.check()
          }
        }
      }
    } else {
      if (!this.$session.exists()) {
        this.$router.push(
          '/Core/Login?access=KNYW6L9LPgSgWPvMzGUBPhPXH52ZdndSpq4Ez8SXMzGu3tBvfEFCrYKK86usU7FE47VKpuVCqe3YPA2CHsnZXshcsKG7A4ZaEWUW&callBack=' +
            this.$route.fullPath
        )
      } else {
        localStorage.setItem(
          'sessionData',
          JSON.stringify(this.$session.getAll().data)
        )
      }
    }
  },
  methods: {
    async check () {
      if (this.$route.query.rewardCode) {
        this.checkCode = this.$route.query.rewardCode
      }
      if (!this.session.data) {
        this.shopId = this.$route.query.shopId
      } else {
        this.shopId = this.session.data.shopId
      }
      console.log('this.session.data', this.session.data)
      await axios
        .get(
          this.DNS_IP +
            '/rewardCode/getData?shopId=' +
            this.shopId +
            '&redeemStatus=get&rewardCode=' +
            this.checkCode
        )
        .then((res) => {
          let rs = res.data
          console.log('res', res.data)
          if (rs.message === 'No data found' || rs.status === false) {
            this.$swal(
              'ข้อมูลไม่ถูกต้อง',
              'กรุณากรอกรหัสให้ถูกต้อง',
              'warning'
            )
            this.checkCode = ''
          } else {
            console.log('res', res.data)
            this.d = rs[0]
            this.status = true
          }
        })
        .catch((error) => {
          console.log('erorororroro', error)
        })
    },
    submit () {
      console.log('enddate', this.d.endDate)
      this.formUpdate.userId = this.session.data.userId
      if (this.d.endDate !== null) {
        var inputDate = new Date(this.d.endDate).getTime()
        console.log('inputDate', inputDate)
        var todaysDate = new Date().getTime()
        console.log('in', todaysDate)
        console.log('in', inputDate)
        if (todaysDate < inputDate) {
          console.log('in')
          let ID = this.d.rewardCodeId
          axios
            .post(this.DNS_IP + '/rewardCode/edit/' + ID, this.formUpdate)
            .then(async (response) => {
              console.log('editDataGlobal DNS_IP + PATH + "edit"', response)

              this.$swal('สำเร็จ', 'แลกของรางวัลสำเร็จแล้ว', 'success')

              this.clear()
            })
        } else {
          this.$swal(
            'ของรางวัลหมดอายุ',
            'ไม่สามารถแลกของรางวัลได้ เนื่องจากเกินกำหนดวันที่แลกของ',
            'warning'
          )
        }
      } else {
        if (this.d.supply === 'coupon') {
          console.log('in')
          let ID = this.d.rewardCodeId
          this.formUpdate2.userId = this.session.data.userId
          axios
            .post(this.DNS_IP + '/rewardCode/edit/' + ID, this.formUpdate2)
            .then(async (response) => {
              console.log('editDataGlobal DNS_IP + PATH + "edit"', response)

              this.$swal('สำเร็จ', 'แลกของรางวัลสำเร็จแล้ว', 'success')

              this.clear()
            })
        } else {
          this.$swal(
            'ของรางวัลหมดอายุ',
            'ไม่สามารถแลกของรางวัลได้ เนื่องจากเกินกำหนดวันที่แลกของ',
            'warning'
          )
        }
      }
    },
    clear () {
      this.checkCode = ''
      this.status = false
      this.d = []
    }
    // async test () {
    //   await axios.post(this.DNS_IP + '/use_package/edit?shopId=' + '' + '&token=' + this.StatusPackage.token, params, {
    //     headers: {
    //       shopId: ''
    //     }
    //   })
    //     .then(response => {
    //       console.log(response.data)
    //     })
    //     .catch(error => {
    //       console.error(error)
    //     })
    // }
  }
}
</script>
<style scoped>
.v-text-field--solo > .v-input__control > .v-input__slot {
  background: #f2f4f9 !important;
}
.padding-colH {
  padding: 5px 15px 0px;
}
.v-expansion-panel-header {
  background-color: white !important;
  color: black !important;
  font-weight: bold !important;
}
</style>

<!-- <template>
  <div>
    <v-main>
      <div>
    <h2>WebSocket Chat</h2>
    <input v-model="message" placeholder="Type a message" @keyup.enter="sendMessage" />
    <button @click="sendMessage">Send</button>

    <h3>Messages</h3>
    <ul>
      <li v-for="(msg, index) in messages" :key="index">
        <strong>{{ msg.sender }}:</strong> {{ msg.content }}
      </li>
    </ul>
  </div>
    </v-main>
  </div>
</template>
<script>
export default {
  data() {
    return {
      socket: null,
      message: "",
      messages: [],
      userID: "user4", // User ปัจจุบัน
      receiverID: "user1", // User ปลายทาง (1-1)
      chatType: "private", // "private" หรือ "group"
      roomID: "group1",
    };
  },
  created() {
    this.socket = new WebSocket(`ws://localhost:5006/ws?user_id=${this.userID}`);

    this.socket.onopen = () => {
      console.log("✅ Connected to WebSocket");
    };

    this.socket.onmessage = (event) => {
      const msg = JSON.parse(event.data);
      console.log("📩 Received:", msg);
      this.messages.push(msg);
    };

    this.socket.onerror = (error) => {
      console.error("❌ WebSocket Error:", error);
    };
  },
  methods: {
    sendMessage() {
      if (this.message.trim() !== "") {
        const msg = {
          type: this.chatType,
          sender: this.userID,
          content: this.message,
        };

        if (this.chatType === "private") {
          msg.receiver = this.receiverID;
        } else if (this.chatType === "group") {
          msg.room_id = this.roomID;
        }

        this.socket.send(JSON.stringify(msg));
        this.message = "";
      }
    },
  },
  beforeDestroy() {
    this.socket.close();
  },
};
</script> -->



// WEBPACK FOOTER //
// src/components/Master/trade.vue